import { useTurnstileToken } from "@/components/results/shared/turnstile";


const KLAVIYO_WORKER_URL =
  "https://paws-klaviyo-worker.paws-on-plates.workers.dev/quiz-completed";

export function useSendQuizToKlaviyo() {
  const getToken = useTurnstileToken();

  return async function sendQuizToKlaviyo(quiz: any) {
    const turnstileToken = await getToken();

    const resp = await fetch(KLAVIYO_WORKER_URL, {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ quiz, turnstileToken }),
    });

    const text = await resp.text();
    if (!resp.ok) throw new Error(`Klaviyo Worker ${resp.status}: ${text}`);

    // Safe JSON parse with fallback
    if (!text) return { ok: true };
    try {
      return JSON.parse(text);
    } catch (e) {
      console.error("Failed to parse Klaviyo response:", e);
      return { ok: true };
    }
  };
}